var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherDust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.94 7.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.64,
    y1: 0.5,
    x2: 6.58,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.8,
    y1: 0.5,
    x2: 10.44,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 0.5,
    x2: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.64,
    y1: 7.02,
    x2: 6.58,
    y2: 7.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.8,
    y1: 7.02,
    x2: 10.44,
    y2: 7.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 7.02,
    x2: 0.5,
    y2: 7.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.58,
    y1: 4.89,
    x2: 6.58,
    y2: 4.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.3,
    y1: 2.75,
    x2: 4.36,
    y2: 2.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 4.87,
    x2: 4.44,
    y2: 4.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.14,
    y1: 2.75,
    x2: 0.5,
    y2: 2.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.44,
    y1: 2.75,
    x2: 10.44,
    y2: 2.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.8,
    y1: 4.87,
    x2: 10.44,
    y2: 4.87
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherDust);
export default __webpack_public_path__ + "static/media/icon_weather_dust.34b6add555531113cb483b478d6f20e5.svg";
export { ForwardRef as ReactComponent };